import { render, staticRenderFns } from "./SuccessTickets.vue?vue&type=template&id=079ca1a8&scoped=true"
import script from "./SuccessTickets.vue?vue&type=script&lang=js"
export * from "./SuccessTickets.vue?vue&type=script&lang=js"
import style0 from "./SuccessTickets.vue?vue&type=style&index=0&id=079ca1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ca1a8",
  null
  
)

export default component.exports